module.exports = __webpack_public_path__ + "static/media/autumnleaf.ddaa12da.webp";